import { EventRegistryReact } from './categories/react/EventRegistryReact';
import { EventRegistryAspect } from './categories/aspect/EventRegistryAspect';
import { EventRegistryQuestion } from './categories/question/EventRegistryQuestion';
import { EventRegistryMedia } from './categories/media/EventRegistryMedia';
import { EventRegistryRuntime } from './categories/runtime/EventRegistryRuntime';
import { RegistryRoof } from '../RegistryRoof';
export class EventRegistry extends RegistryRoof {
    registryType = 'event';
    c_a = new EventRegistryAspect(this);
    c_re = new EventRegistryReact(this);
    c_q = new EventRegistryQuestion(this);
    c_m = new EventRegistryMedia(this);
    c_r = new EventRegistryRuntime(this);
    get allLeafs() {
        return super.allLeafs;
    }
    get registry_object() {
        return super.registry_object;
    }
    typeByHandlerName(handlerName) {
        return this.allLeafs.find(item => item.handlerName === handlerName);
    }
}
